import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  tramitar,
} from "./actions";

import {
  buscarProcesso,
  quandoMudar,
  enviarComentario as enviar
} from "paginas/processo/actions";

import Pagina from 'componentes/Pagina';
import ProcessoTramitacaoForm from 'componentes/ProcessoTramitacaoForm';
import ProcessoDetalhe from 'componentes/ProcessoDetalhe';

import Anexo from "componentes/anexo";
import Comentario from "componentes/Comentario";

class TramitacaoProcesso extends Component {
  componentDidMount() {
    const { id, processo: { id: processoId }, buscarProcesso } = this.props;
    if (id && id !== processoId) {
      return buscarProcesso(id);
    }
  }

  render() {
    const titulo = "Tramitar Processo";
    return (
      <Pagina title={titulo} breadcrumbs={[{ name: titulo, active: true }]} >
        <ProcessoDetalhe />
        <ProcessoTramitacaoForm {...this.props} />
        <Anexo />
        <Comentario {...this.props} />
      </Pagina>
    );
  }
}

const mapStateToProps = (state, { history, match: { params: { id, de } } }) => ({
  id: id ? parseInt(id, 10) : "",
  de,
  history,
  processo: state.processo.processo,
  situacoes: state.processo.situacoes,
  responsaveis: state.processo.responsaveis,
  parecerId: state.parecer.parecer.id,
  anexos: state.anexo.anexos,
  alegacoes: state.processo.alegacoes
})

const mapDispatchToProps = dispatch => bindActionCreators({
  buscarProcesso,
  quandoMudar,
  tramitar,
  enviar
}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TramitacaoProcesso))


// WEBPACK FOOTER //
// ./src/paginas/tramitacao/index.js